import { PkBottomPanel, PkButton } from '@uefadigital/panenka-react';
import { memo, useRef } from 'react';

import { useTeam } from '../../store';
import { clickTracking } from '../../utils/tracking';

import { useTranslateFn } from '@shared/Translate';
import IdpHandler from '@user/IdpHandler';

import * as styles from '../styles.module.scss';

const JoinMyUefa = () => {
  const t = useTranslateFn();
  const { status } = useTeam();
  const panelRef = useRef<HTMLPkBottomPanelElement>(null);
  const skipCloseTracking = useRef<boolean>(false);

  const setMyUefa = () => {
    IdpHandler.showRegister();
    clickTracking('join MyUEFA', 'Dialog - Main action', 'panel_dialog_main_action');
  };

  const closeDialog = () => {
    !skipCloseTracking.current && clickTracking('join MyUEFA', 'Dialog - Skip', 'panel_dialog_skip');
  };

  const handleClick = () => {
    clickTracking('join MyUEFA', 'Dialog - Secondary action', 'panel_dialog_secondary_action');
    skipCloseTracking.current = true;
    panelRef.current.close();
  };

  return (
    <PkBottomPanel opened={status === 'joining'} ref={panelRef} onPkClose={closeDialog} focusOnOpen>
      <div slot='title' className='pk-d--flex pk-mb--0'>
        <div className={styles.panelMyuefaIcon} />
        <div className='pk-d--flex pk-flex--column pk-ml--m'>
          <div className={styles.panelTitle}>{t('join_myuefa_followed_teams')}</div>
          <div className={styles.panelSummary}>{t('join_myuefa_followed_teams_summary')}</div>
        </div>
      </div>

      <div slot='actions'>
        <PkButton className='pk-w--100' aria-label={t('join_myuefa')} onPkClick={setMyUefa}>
          {t('join_myuefa')}
        </PkButton>
        <PkButton
          className='pk-w--100 pk-mt--m'
          aria-label={t('not_now')}
          onPkClick={handleClick}
          appearance='outlined'
        >
          {t('not_now')}
        </PkButton>
      </div>
    </PkBottomPanel>
  );
};

export default memo(JoinMyUefa);
